<template>
    <v-card style="border-top: 3px solid blue">
        <v-card-title class="pa-2 d-flex flex-column justify-start align-start">
            <flight-tariff-label :tariff="offer.tariff" />
            <div class="text-caption">
                <template v-if="!offer.soldOut">
                    <supplier-price v-if="isTO1" :supplier-price="offer.supplierPrice" />
                    <div class="text-h5 d-flex align-center">
                        <div v-if="offer.price" class="text-right">
                            <price-label :price="offer.price" :content-class="'text-h6 mb-1'" convert-price column />
                            <discount-label :price="offer.price" class="d-inline-block mt-1" />
                        </div>
                        <corporate-policy-violation
                            v-if="offer.corporatePolicyViolation"
                            :policies="offer.corporatePolicy"
                        />
                        <price-details-btn class="text-body-1" :offer="offer" />
                    </div>
                    <commission-amount v-if="offer.price" :commission="offer.price.commission" />
                    <flight-conditions-label
                        class="mb-1"
                        small
                        :offer-key="offer.offerKey"
                        :price="offer.price"
                        :refundable="offer.refundable"
                        :regular="offer.regular"
                        @conditions="showConditionsInfo"
                    />
                </template>
            </div>
        </v-card-title>
        <v-divider />
        <v-card-text class="text-black">
            <div v-for="(tarif, index) in offer.tariff" :key="`${offer.offerKey}-tarif-${index}`">
                <v-row v-if="tarif.description && tarif.description.length" no-gutters class="py-3">
                    <v-list density="compact">
                        <v-list-item
                            v-for="(desc, descIndex) in tarif.description"
                            :key="`${desc.type}-${descIndex}`"
                            cols="12"
                            class="disabled text-caption"
                            density="compact"
                        >
                            <v-icon start :color="!desc.notOffered ? 'info' : 'grey'" size="small">
                                {{ getIcon(desc.type, !desc.notOffered) }}
                            </v-icon>
                            <span :class="{'text-grey': desc.notOffered}"> {{ desc.text }} </span>
                            <v-tooltip v-if="!desc.notOffered && !desc.included" location="top">
                                <template v-slot:activator="{props}">
                                    <v-icon end size="x-small" color="error" v-bind="props">mdi-star</v-icon>
                                </template>
                                <span class="text-caption">
                                    {{ $t('flights.extra_price_available') }}
                                </span>
                            </v-tooltip>
                            <span v-if="desc.notOffered" class="text-grey text-caption">
                                &nbsp;({{ $t('not_available') }})
                            </span>
                        </v-list-item>
                    </v-list>
                    <!-- <v-col v-for="desc in tarif.description" :key="desc.TYPE" cols="12" class="disabled caption">
                    </v-col> -->
                </v-row>
            </div>
            <fare-rules :offer-key="offer.offerKey" class="mt-1" />
            <flight-baggage-allowances :offer="offer" class="mt-1" />
        </v-card-text>
        <v-card-actions>
            <v-btn color="info" block @click="selectForBooking">
                {{ $t('book') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SupplierPrice from '~/components/snippets/SupplierPrice.vue'
    import CorporatePolicyViolation from '~/components/snippets/CorporatePolicyViolation.vue'
    import DiscountLabel from '~/components/snippets/DiscountLabel.vue'
    import FlightConditionsLabel from '~/components/flights/snippets/FlightConditionsLabel.vue'
    import PriceLabel from '~/components/snippets/PriceLabel.vue'
    import PriceDetailsBtn from '~/components/flights/PriceDetailsBtn.vue'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import FlightBaggageAllowances from '~/components/flights/search/offers/FlightBaggageAllowances.vue'
    import FareRules from '~/components/flights/FareRules.vue'
    import FlightTariffLabel from '~/components/flights/search/offers/FlightTariffLabel.vue'

    @Component({
        components: {
            FareRules,
            FlightBaggageAllowances,
            CommissionAmount,
            PriceDetailsBtn,
            PriceLabel,
            FlightConditionsLabel,
            DiscountLabel,
            CorporatePolicyViolation,
            SupplierPrice,
            FlightTariffLabel,
        },
    })
    export class FareOffer extends Vue {
        @Prop() offer

        PRICE_TYPES = {client: 'CLIENT'}

        selectForBooking() {
            flightsStore.ADD_TO_BASKET(this.offer)
            this.$router.push({name: 'flightBooking', query: {offerKey: this.offer.offerKey}})
        }

        getIcon(type, isAvailable) {
            if (!isAvailable) {
                return 'mdi-minus-circle'
            }
            switch (type) {
                case 'BG':
                    return 'mdi-bag-checked'
                case 'TS':
                    return 'mdi-cog'
                case 'ML':
                    return 'mdi-food'

                default:
                    return 'mdi-star-circle-outline'
            }
        }
    }

    export default FareOffer
</script>
